import { BackendError, Service } from '@genial/services';
import { ResponsesStatementFixedIncomeResponse } from '@genial/services/dist/models';
import { selectorFamily } from 'recoil';

import { advisorIdToApisSelector, partnerIdToApisSelector } from '../../../master/selector';
import { screenName } from '../../constants';
import { statementsFilterParamsState } from '../atom';
import { FixedIncomeStatementsParamsProps } from '../types';

export const fixedIncomeStatementsQuery = selectorFamily<
  | {
      data: ResponsesStatementFixedIncomeResponse[];
    }
  | null
  | undefined,
  { accountNumber: number; callEndpoint?: boolean }
>({
  key: 'CustomerDetail/fixedIncomeStatementsQuery',
  get: ({ accountNumber, callEndpoint }) => {
    return async ({ get }) => {
      const responseEmpty = { data: [] as ResponsesStatementFixedIncomeResponse[] };

      if (!callEndpoint) {
        return responseEmpty;
      }

      try {
        const params = get(statementsFilterParamsState) as FixedIncomeStatementsParamsProps;
        const advisorSelected = get(advisorIdToApisSelector);
        const partnerSelected = get(partnerIdToApisSelector);

        const { data } = await Service.Finance.V1.getStatementByFixedIncomeAccountNumber({
          ...params,
          screenName,
          advisorId: advisorSelected,
          partnerId: partnerSelected,
          accountNumber,
        });

        const response = { data: data || responseEmpty.data };
        return response;
      } catch (error) {
        const backendError = error as BackendError;

        if (backendError.statusCode === 404) {
          return responseEmpty;
        }

        throw error;
      }
    };
  },
});
